// extracted by mini-css-extract-plugin
export default {"container":"J3-z","list":"K3-z"};